<template>
    <div id="liquidacion" style="width: 100%">
        <!-- Desktop view -->
        <v-tabs
            v-if="!$vuetify.breakpoint.smAndDown"
            v-model="tab"
            class="pb-2"
            style="background-color: transparent"
            centered
            fixed-tabs
        >
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
                Paquetes
                <v-icon>mdi-package</v-icon>
            </v-tab>

            <v-tab href="#tab-2">
                Gestiones
                <v-icon>mdi-offer</v-icon>
            </v-tab>

            <v-tab v-if="selectedComercial" href="#tab-3">
                Calculadora
                <v-icon>mdi-calculator</v-icon>
            </v-tab>
        </v-tabs>

        <!-- Desktop view -->
        <v-col v-if="!$vuetify.breakpoint.smAndDown" cols="12">
            <v-toolbar
                flat
                style="background-color: transparent"
                class="mt-1 d-flex justify-center"
            >
                <v-btn
                    depressed
                    v-if="hasAdminPermission"
                    class="overline mr-md-2"
                    color="purple"
                    dark
                    @click="
                        isOpenDownloadTemplateAndUpload = true;
                        uploadMessage = 'subir archivo con las liquidaciones';
                        uploadAction = 'Procesando la liquidación';
                        title = 'Subir liquidación';
                        templateMutationPath = '';
                        submitPath = 'download_liquidacion_comercial';
                        multiple = true;
                    "
                >
                    Liquidación
                    <v-icon right>mdi-cash-multiple</v-icon>
                </v-btn>
                <v-btn
                    class="overline white--text"
                    depressed
                    color="#2c3a5c"
                    @click="thisMonth"
                >
                    Este mes
                    <v-icon class="ml-1">mdi-calendar</v-icon>
                </v-btn>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                    :disabled="isLoadingObjetivos"
                >
                    <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title v-if="isExporting" class="overline mx-3">
                    <h3>{{ exportingProgress.toFixed(1) + ' %' }}</h3>
                </v-toolbar-title>
                <v-toolbar-title v-else class="overline">
                    <h3>{{ currentNameMonthYear }}</h3>
                </v-toolbar-title>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                    :disabled="isLoadingObjetivos"
                >
                    <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                    depressed
                    v-if="hasManagerPermission"
                    dark
                    class="overline mr-md-2"
                    color="blue darken-1"
                    @click="download"
                >
                    Descargar
                    <v-icon right>mdi-download</v-icon>
                </v-btn>
                <v-btn
                    v-if="hasAdminPermission"
                    class="overline mr-md-2"
                    color="warning"
                    depressed
                    dark
                    @click="
                        isOpenDownloadTemplateAndUpload = true;
                        uploadMessage = 'subir archivo con las liquidaciones';
                        uploadAction = 'Procesando la liquidación general';
                        title = 'Subir liquidación general';
                        templateMutationPath = '';
                        submitPath = 'download_liquidacion_general';
                        multiple = true;
                    "
                >
                    L.general
                    <v-icon small>mdi-cash</v-icon>
                </v-btn>
            </v-toolbar>
            <v-progress-linear
                v-if="isExporting && hasAdminPermission"
                :value="exportingProgress"
                :indeterminate="exportingProgress == 0"
                height="4"
                color="#4CAF50"
                background-color="grey lighten-2"
            >
            </v-progress-linear>
        </v-col>

        <!-- Mobile view -->
        <v-col v-if="$vuetify.breakpoint.smAndDown" no-gutters>
            <v-progress-linear
                v-if="isExporting"
                :value="exportingProgress"
                class="mb-n1"
            ></v-progress-linear>
            <v-toolbar
                class="mt-1 d-flex justify-center"
                style="z-index: 2 !important"
            >
                <div class="d-flex align-center">
                    <v-speed-dial
                        v-if="hasManagerPermission"
                        v-model="fab"
                        :open-on-hover="false"
                        direction="bottom"
                        transition="slide-y-transition"
                    >
                        <template v-slot:activator>
                            <v-btn v-model="fab" icon>
                                <v-icon large v-if="fab"> mdi-close </v-icon>
                                <v-icon v-else large>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-btn
                            class="overline mr-md-2"
                            color="purple"
                            fab
                            small
                            dark
                            style="z-index: 50"
                            @click="
                                isOpenDownloadTemplateAndUpload = true;
                                uploadMessage =
                                    'subir archivo con las liquidaciones';
                                uploadAction = 'Procesando la liquidación';
                                title = 'Subir liquidación';
                                templateMutationPath = '';
                                submitPath = 'download_liquidacion_comercial';
                                multiple = true;
                            "
                        >
                            <v-icon small>mdi-cash-multiple</v-icon>
                        </v-btn>
                        <v-btn
                            class="overline mr-md-2"
                            color="warning"
                            fab
                            small
                            dark
                            style="z-index: 50"
                            @click="
                                isOpenDownloadTemplateAndUpload = true;
                                uploadMessage =
                                    'subir archivo con las liquidaciones';
                                uploadAction =
                                    'Procesando la liquidación general';
                                title = 'Subir liquidación general';
                                templateMutationPath = '';
                                submitPath = 'download_liquidacion_general';
                                multiple = true;
                            "
                        >
                            <v-icon small>mdi-cash</v-icon>
                        </v-btn>
                        <v-btn
                            fab
                            small
                            class="overline"
                            color="primary"
                            style="z-index: 175163521254319"
                            @click="thisMonth"
                            :disabled="isLoadingObjetivos"
                        >
                            <v-icon small>mdi-calendar</v-icon>
                        </v-btn>
                    </v-speed-dial>
                    <v-btn
                        v-if="!hasManagerPermission"
                        fab
                        small
                        class="overline"
                        color="primary"
                        style="z-index: 175163521254319"
                        @click="thisMonth"
                        :disabled="isLoadingObjetivos"
                    >
                        <v-icon small>mdi-calendar</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        text
                        small
                        color="grey darken-2"
                        :disabled="isLoadingObjetivos"
                        @click="prev"
                    >
                        <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="isExporting" class="overline mx-3">
                        <h3>{{ exportingProgress.toFixed(1) + ' %' }}</h3>
                    </v-toolbar-title>
                    <v-toolbar-title v-else class="overline">
                        <h3>{{ currentNameMonthYear }}</h3>
                    </v-toolbar-title>
                    <v-btn
                        fab
                        text
                        small
                        :disabled="isLoadingObjetivos"
                        color="grey darken-2"
                        @click="next"
                    >
                        <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>

                    <v-speed-dial
                        v-if="hasManagerPermission"
                        v-model="fab1"
                        :open-on-hover="false"
                        direction="bottom"
                        transition="slide-y-transition"
                    >
                        <template v-slot:activator>
                            <v-btn v-model="fab1" icon>
                                <v-icon large v-if="fab1"> mdi-close </v-icon>
                                <v-icon v-else large>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-btn
                            fab
                            dark
                            small
                            class="overline"
                            color="blue darken-1"
                            @click="download"
                        >
                            <v-icon small>mdi-download</v-icon>
                        </v-btn>
                    </v-speed-dial>
                </div>
            </v-toolbar>
        </v-col>

        <!-- Selector de comercial -->
        <v-row no-gutters>
            <v-select
                v-if="$store.getters['login/hasManagerPermission']"
                :disabled="isLoadingObjetivos"
                class="pa-4"
                :items="comerciales"
                v-model="selectedComercial"
                item-text="nombreCompleto"
                return-object
                prepend-inner-icon="mdi-account"
                hint="Selecciona un comercial para ver sus ofertas y objetivos"
                persistent-hint
                :menu-props="{ maxHeight: '600' }"
                label="Comercial"
                clearable
            >
                <template #item="{ item }">
                    <v-row>
                        <v-col cols="11">
                            {{ item.nombreCompleto }}
                        </v-col>
                        <v-col
                            v-if="item.estado && !$vuetify.breakpoint.smAndDown"
                            cols="1"
                        >
                            <v-chip
                                label
                                :color="estadoComercial[item.estado]"
                                medium
                                class="d-flex justify-center overline"
                            >
                                {{ item.estado }}
                            </v-chip>
                        </v-col>
                        <v-col
                            v-if="item.estado && $vuetify.breakpoint.smAndDown"
                            cols="1"
                        >
                            <v-icon
                                :color="estadoComercial[item.estado]"
                                large
                                class="d-flex justify-center overline"
                            >
                                mdi-circle
                            </v-icon>
                        </v-col>
                    </v-row>
                </template>
            </v-select>
        </v-row>

        <!-- Desktop view -->
        <v-tabs-items
            v-if="!$vuetify.breakpoint.smAndDown"
            v-model="tab"
            class="ma-1 pa-2"
            style="background-color: #f6f8fe"
        >
            <v-tab-item value="tab-1">
                <TablaPaquetes :currentDate="currentDate" />
            </v-tab-item>
            <v-tab-item value="tab-2">
                <TablaGestionesLiq :currentDate="currentDate" class="mt-4" />
            </v-tab-item>
            <v-tab-item v-if="selectedComercial" value="tab-3">
                <v-row class="mx-2">
                    <v-col
                        cols="12"
                        v-if="
                            (selectedComercial && hasManagerPermission) ||
                            hasComercialPermission
                        "
                    >
                        <v-row>
                            <v-col cols="12">
                                <TablaObjetivos />
                            </v-col>
                        </v-row>
                        <v-row class="mt-1">
                            <v-col cols="5">
                                <TablaBolsa />
                                <v-btn
                                    width="100%"
                                    :disabled="
                                        factor_corrector.length == 0 ||
                                        isLoadingObjetivos
                                    "
                                    color="primary"
                                    x-large
                                    @click="openViewFactor"
                                    >FACTOR CORRECTOR
                                </v-btn>
                                <CorrectiveFactorView />
                            </v-col>
                            <v-col cols="7" class="mb-1">
                                <TablaLlave />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>

        <!-- Mobile view -->
        <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
            <v-expansion-panels>
                <v-expansion-panel class="pa-0">
                    <v-expansion-panel-header>
                        <p class="text-center overline">
                            Seguimiento de paquetes
                        </p>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content id="innerExPan">
                        <TablaPaquetes :currentDate="currentDate" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="my-1">
                    <v-expansion-panel-header>
                        <p class="text-center overline">
                            Seguimiento de gestiones
                        </p>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content id="innerExPan">
                        <TablaGestionesLiq :currentDate="currentDate" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="my-1" v-if="selectedComercial">
                    <v-expansion-panel-header>
                        <p class="text-center overline">
                            Seguimiento de objetivos
                        </p>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content id="innerExPan">
                        <v-responsive>
                            <TablaObjetivos />
                            <TablaBolsa />
                            <v-btn
                                width="100%"
                                color="primary"
                                x-large
                                @click="openViewFactor"
                                >FACTOR CORRECTOR
                            </v-btn>
                            <CorrectiveFactorView />
                            <TablaLlave />
                        </v-responsive>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>

        <DownloadTemplateAndUpload
            :message="uploadMessage"
            :multiple="multiple"
            :title="title"
            :templateMutationPath="templateMutationPath"
            submitMutationPath="gerencia/importFiles"
            :submitPath="submitPath"
            datePicker="True"
        />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { estadoComercial, dateToISOString } from '@/util/libUtil.js';

import TablaPaquetes from '@/components/AreaPersonal/Liquidacion/TablaPaquetes.vue';
import TablaGestionesLiq from '@/components/AreaPersonal/Liquidacion/TablaGestionesLiq.vue';
import TablaObjetivos from '@/components/AreaPersonal/Calculadora/TablaObjetivos.vue';
import TablaBolsa from '@/components/AreaPersonal/Calculadora/TablaBolsa.vue';
// import FactorCorrector from '@/components/AreaPersonal/Calculadora/FactorCorrector/FactorCorrector.vue';
import TablaLlave from '@/components/AreaPersonal/Calculadora/TablaLlave.vue';
import CorrectiveFactorView from '@/components/AreaPersonal/Calculadora/FactorCorrector/correctiveFactorView.vue';
import DownloadTemplateAndUpload from '@/components/DownloadTemplateAndUpload/DownloadTemplateAndUpload.vue';

export default {
    name: 'Liquidacion',
    components: {
        TablaPaquetes,
        TablaGestionesLiq,
        TablaObjetivos,
        TablaBolsa,
        CorrectiveFactorView,
        // FactorCorrector,
        TablaLlave,
        DownloadTemplateAndUpload,
    },
    data: () => ({
        fab: 0,
        fab1: 0,
        tab: 0,
        submitPath: '',
        uploadMessage: '',
        uploadAction: '',
        title: '',
        multiple: false,
        templateMutationPath: '',
        estadoComercial,
    }),
    computed: {
        isOpenDownloadTemplateAndUpload: {
            get() {
                return this.$store.state.util.isOpenDownloadTemplateAndUpload;
            },
            set(val) {
                this.$store.commit('util/isOpenDownloadTemplateAndUpload', val);
            },
        },
        currentDate: {
            get() {
                return this.$store.state.areaPersonal.calculadora.date;
            },
            set(val) {
                this.$store.commit('areaPersonal/calculadora/date', val);
            },
        },
        selectedComercial: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .selectedComercial;
            },
            set(val) {
                this.$store.commit(
                    'areaPersonal/calculadora/selectedComercial',
                    val
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('areaPersonal/calculadora', {
            factor_corrector: (state) => state.factor_corrector,
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
    methods: {
        updateReward(newValue) {
            if (this.hasManagerPermission && this.selectedComercial) {
                let params = {
                    commercial: this.selectedComercial.id,
                    created_on: `${this.currentDate.getFullYear()}-${
                        this.currentDate.getMonth() + 1
                    }`,
                };

                if (dateToISOString(newValue) >= this.dateActualInmutable) {
                    params = { ...params, is_active: true };
                }

                // this.$store.dispatch(
                //     'areaPersonal/calculadora/fetchRewardType',
                //     params
                // );
            } else if (this.hasComercialPermission) {
                let params = {
                    commercial: this.cuenta.id,
                    created_on: `${this.currentDate.getFullYear()}-${
                        this.currentDate.getMonth() + 1
                    }`,
                };

                if (dateToISOString(newValue) >= this.dateActualInmutable) {
                    params = { ...params, is_active: true };
                }

                // this.$store.dispatch(
                //     'areaPersonal/calculadora/fetchRewardType',
                //     params
                // );
            }
        },
        download() {
            this.$store.dispatch('areaPersonal/calculadora/exportDB');
        },
        openViewFactor() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenViewFactor',
                true
            );
        },
        thisMonth() {
            this.$store.commit('areaPersonal/calculadora/date', new Date());
        },
        prev() {
            const copy = this.currentDate;
            copy.setDate(0);
            // copy.setMonth(this.currentDate.getMonth() - 1, 1);
            this.currentDate = new Date(copy);
        },
        next() {
            const copy = this.currentDate;
            copy.setMonth(this.currentDate.getMonth() + 1, 1);
            this.currentDate = new Date(copy);
        },
        ...mapActions('areaPersonal/calculadora', ['fetchObjetivo']),
    },
    created() {
        if (this.$store.state.teletrabajo.Comerciales.length === 0) {
            this.$store.dispatch('teletrabajo/fetchComerciales');
        }
    },
    watch: {
        selectedComercial: {
            immediate: true,
            handler(newValue, oldValue) {
                if (this.selectedComercial)
                    this.fetchObjetivo({
                        comercialId: this.selectedComercial.id,
                        soldOut: true,
                    });
                else
                    this.$store.commit(
                        'areaPersonal/calculadora/objetivoComercial',
                        []
                    );
            },
        },
        currentDate: {
            immediate: true,
            handler: function (newValue, oldValue) {
                this.updateReward(newValue);
                if (this.selectedComercial)
                    this.fetchObjetivo({
                        comercialId: this.selectedComercial.id,
                        soldOut: true,
                    });
            },
        },
    },
};
</script>

<style>
</style>